import { showToast } from './utils.js';
import { setIcon } from './icons.js';

export function isTerminalOn() {
  return false;
}

export function forceDarkForTerminal() {}

export function updateThemeMeta() {
  const light = document.documentElement.classList.contains('light');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.content = light ? '#eef3f8' : '#0c1016';
}

export function updateThemeIcon() {
  const light = document.documentElement.classList.contains('light');
  const btn = document.getElementById('themeToggle');
  if (!btn) return;
  setIcon(btn, light ? 'moon' : 'sun');
  btn.classList.toggle('is-on', light);
  btn.title = light ? 'Light mode — tap for dark' : 'Dark mode — tap for light';
  btn.setAttribute('aria-label', light ? 'Switch to dark mode' : 'Switch to light mode');
}

export function toggleTheme() {
  const light = document.documentElement.classList.toggle('light');
  localStorage.setItem('mysky_theme', light ? 'light' : 'dark');
  updateThemeIcon();
  updateThemeMeta();
  showToast(light ? 'Light mode' : 'Dark mode');
}

export function toggleTerminal() {}

export function updateTerminalButton() {}

export function syncThemeToggleDisabled() {}

export function initThemeControls() {
  updateThemeIcon();
  updateThemeMeta();
}
